module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"MY_ACCOUNT":"MON COMPTE","MY_PREFERENCES":"Mes préférences","prefLang":"Langue de l\u0027interface"},"en":{"MY_ACCOUNT":"MY ACCOUNT","MY_PREFERENCES":"Settings","prefLang":"Language"}}')
  delete Component.options._Ctor
}
